import { render, staticRenderFns } from "./reservar.vue?vue&type=template&id=389c4f02"
import script from "./reservar.vue?vue&type=script&lang=js"
export * from "./reservar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports